export default __webpack_public_path__ + "static/media/workout.df2a227c.mp4";